import { createI18n } from 'vue-i18n'
import fa from './locales/fa.js'
import en from './locales/en.js'

const STORAGE_KEY = 'moroorato_admin_locale'

// Persian is the primary locale and the app ships RTL. The locale is persisted so an operator's choice
// sticks, and `applyDirection` keeps <html dir/lang> in sync for correct bidi rendering.
export const SUPPORTED_LOCALES = [
  { code: 'fa', name: 'فارسی', dir: 'rtl' },
  { code: 'en', name: 'English', dir: 'ltr' },
]

const stored = (typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY)) || 'fa'
const initialLocale = SUPPORTED_LOCALES.some((l) => l.code === stored) ? stored : 'fa'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: 'fa',
  messages: { fa, en },
})

export const directionFor = (code) => SUPPORTED_LOCALES.find((l) => l.code === code)?.dir || 'rtl'

export const applyDirection = (code = i18n.global.locale.value) => {
  if (typeof document === 'undefined') {
    return
  }
  document.documentElement.setAttribute('lang', code)
  document.documentElement.setAttribute('dir', directionFor(code))
}

export const setLocale = (code) => {
  if (!SUPPORTED_LOCALES.some((l) => l.code === code)) {
    return
  }
  i18n.global.locale.value = code
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, code)
  }
  applyDirection(code)
}

export default i18n
